/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllReferralCareAttributes200ResponseDataInner
 */
export interface FindAllReferralCareAttributes200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof FindAllReferralCareAttributes200ResponseDataInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllReferralCareAttributes200ResponseDataInner
     */
    category: FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof FindAllReferralCareAttributes200ResponseDataInner
     */
    label: string;
}


/**
 * @export
 */
export const FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care'
} as const;
export type FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum = typeof FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum[keyof typeof FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum];


/**
 * Check if a given object implements the FindAllReferralCareAttributes200ResponseDataInner interface.
 */
export function instanceOfFindAllReferralCareAttributes200ResponseDataInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function FindAllReferralCareAttributes200ResponseDataInnerFromJSON(json: any): FindAllReferralCareAttributes200ResponseDataInner {
    return FindAllReferralCareAttributes200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllReferralCareAttributes200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllReferralCareAttributes200ResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'category': json['category'],
        'label': json['label'],
    };
}

export function FindAllReferralCareAttributes200ResponseDataInnerToJSON(value?: FindAllReferralCareAttributes200ResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'category': value.category,
        'label': value.label,
    };
}

